import Global from "./chinese/chinese-global";
import Error from "./chinese/chinese-error";
import Authentication from "./chinese/chinese-authentication";

export default {
  Languages: {
    Global,
    Error,
    Authentication,
  }
};
